import {DscrIndustry, getDscrIndustryNames} from '../../const';

export type DscrIndustrySelectionValue = DscrIndustry | null;

export const DscrIndustrySelectionValueOptions: DscrIndustry[] = getDscrIndustryNames();
